import React from 'react'

const DynamicBackground = () => {
  return (
    <div className="fixed inset-0 -z-50 overflow-hidden pointer-events-none">
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-background via-background to-background opacity-90 transition-colors duration-500 ease-in-out" />
      
      {/* Dynamic Orbs */}
      <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-purple-400/30 blur-[100px] animate-blob mix-blend-multiply filter dark:bg-purple-900/20 dark:mix-blend-normal" />
      <div className="absolute top-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-blue-400/30 delay-2000 blur-[100px] animate-blob mix-blend-multiply filter dark:bg-blue-900/20 dark:mix-blend-normal" />
      <div className="absolute bottom-[-10%] left-[20%] w-[50%] h-[50%] rounded-full bg-pink-400/30 delay-4000 blur-[100px] animate-blob mix-blend-multiply filter dark:bg-pink-900/20 dark:mix-blend-normal" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-indigo-400/30 delay-6000 blur-[120px] animate-blob mix-blend-multiply filter dark:bg-indigo-900/20 dark:mix-blend-normal" />

      {/* Grid Overlay for Texture */}
      <div className="absolute inset-0 bg-[url('/grid.svg')] opacity-[0.02] dark:opacity-[0.05]" />
    </div>
  )
}

export default DynamicBackground
